import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import Seo from '../components/Seo';
import { AREAS } from '../data/areas';
import { ADDRESS_LINE } from '../data/seoContent';

const AreasPage = () => (
  <>
    <Seo page="/areas" />
    <div className="pt-36 pb-20" data-testid="areas-page">
      <div className="max-w-5xl mx-auto px-4">
        <h1 className="font-['Barlow_Condensed'] text-4xl sm:text-5xl lg:text-6xl font-bold uppercase text-[#0E3D95] mb-4">Areas We Serve</h1>
        <p className="text-lg text-slate-600 mb-8">
          From our showroom at {ADDRESS_LINE}, Leisure Wellness Naples delivers, installs and services hot tubs, swim spas, saunas and cold plunges across Collier and Lee County.
        </p>
        <div className="grid sm:grid-cols-2 gap-4">
          <Link to="/" className="p-5 rounded-xl bg-white shadow-sm border border-[#0E3D95]/10 hover:shadow-md transition-shadow" data-testid="area-link-naples">
            <p className="font-bold text-[#0E3D95] flex items-center gap-2"><MapPin size={18} className="text-[#F88200]" /> Naples, FL</p>
            <p className="text-sm text-slate-600">Home of our North Naples showroom</p>
          </Link>
          {AREAS.map((a) => (
            <Link key={a.slug} to={`/areas/${a.slug}`} className="p-5 rounded-xl bg-white shadow-sm border border-[#0E3D95]/10 hover:shadow-md transition-shadow" data-testid={`area-link-${a.slug}`}>
              <p className="font-bold text-[#0E3D95] flex items-center gap-2"><MapPin size={18} className="text-[#F88200]" /> {a.city}, FL</p>
              <p className="text-sm text-slate-600">{a.county} · showroom {a.drive} away</p>
            </Link>
          ))}
        </div>
      </div>
    </div>
  </>
);

export default AreasPage;
